"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import {
  createBrowserHistory,
  createLocation,
  createPath,
  parsePath
} from "history";
import queryString from "query-string";
import { dequal } from "dequal";
function searchFor(query) {
  const search = queryString.stringify(query).replace(/%20/g, "+");
  return search ? `?${search}` : "";
}
export function toLocation(input) {
  const _a = typeof input === "string" ? parsePath(input) : input, { query } = _a, location = __objRest(_a, ["query"]);
  const pathname = location.pathname || "/";
  return __spreadProps(__spreadValues({}, location), {
    pathname: pathname.charAt(0) === "/" ? pathname : `/${pathname}`,
    search: query == null ? location.search : searchFor(query)
  });
}
function stripBasename(path, basename) {
  const hasBasename = path.toLowerCase().indexOf(basename.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(basename.length)) !== -1;
  return hasBasename ? path.substring(basename.length) : path;
}
export { parsePath };
export default function createLegacyHistory(basename) {
  const history = createBrowserHistory({ basename });
  function legacyLocation(location, action) {
    return __spreadProps(__spreadValues({}, location), {
      query: queryString.parse(location.search),
      basename,
      action
    });
  }
  return {
    get length() {
      return history.length;
    },
    get action() {
      return history.action;
    },
    get location() {
      return legacyLocation(history.location, history.action);
    },
    // Read from the browser rather than history's own copy, which misses
    // URLs that Elm's ports push without going through it.
    getCurrentLocation() {
      const { pathname, search, hash } = window.location;
      const { key, state } = window.history.state || {};
      const path = stripBasename(pathname + search + hash, basename);
      return legacyLocation(createLocation(path, state, key), "POP");
    },
    // Hands each listener the location as of its turn, as history 3 did: a
    // listener that redirects leaves the later ones seeing the redirect.
    listen(listener) {
      return history.listen(
        () => listener(
          legacyLocation(history.location, history.action),
          history.action
        )
      );
    },
    push(input) {
      const location = toLocation(input);
      const current = history.location;
      const samePath = createPath(createLocation(location)) === createPath(current);
      if (samePath && dequal(location.state, current.state)) {
        history.replace(location);
      } else {
        history.push(location);
      }
    },
    replace(input) {
      history.replace(toLocation(input));
    },
    createHref(input) {
      return history.createHref(toLocation(input));
    },
    go: (n) => history.go(n),
    goBack: () => history.goBack(),
    goForward: () => history.goForward(),
    block: (prompt) => history.block(prompt)
  };
}
